import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

export function Skeleton({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden
      className={cn('animate-pulse rounded-md bg-slate-200/80', className)}
      {...rest}
    />
  )
}

/**
 * SkeletonRows — placeholder de filas mientras la tabla carga.
 *
 * F7.6 bug fix MCP: antes renderizaba `<div>` dentro de `<tbody>`, causando hydration warning
 * "In HTML, <div> cannot be a child of <tbody>". Ahora renderiza `<tr><td>` válido HTML.
 *
 * Uso EXCLUSIVO dentro de `<TableBody>`. Para skeleton fuera de tabla, usar `<Skeleton>` directo.
 */
export function SkeletonRows({ rows = 5, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={i} aria-hidden>
          {Array.from({ length: cols }).map((__, j) => (
            <td key={j} className="px-3 py-2">
              <Skeleton className="h-5 w-full" />
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}
